import { FC, useEffect } from "react";
import { AIFormInput, AISelect, AIText, I_formNode, useForm } from "./../../../components/aio/aio-input";
import { useFreelancerProvider, useRootFreelancerProvider } from "../context";
import Icon from "@mdi/react";
import { mdiCalendar, mdiInformationOutline } from "@mdi/js";
import { I_model } from "../types";

export const CarInfoForm: FC<{
    data: I_model,
    onChange: (v: I_model) => void,
    setDisabled: (v: boolean) => void
}> = (props) => {
    const { options } = useRootFreelancerProvider()
    const { inputCls } = useFreelancerProvider()
    const form = useForm<I_model & {
        plate: string[]
    }>({
        data: {
            ...props.data,
            vehicleType:props.data.vehicleType || {id:0},
            vehicleMake:props.data.vehicleMake || {id:0},
            plate: [
                props.data.vehicleNumberPart0,
                props.data.vehicleNumberPart1,
                props.data.vehicleNumberPart2,
                props.data.vehicleNumberPart3,
            ]
        },
        fa: true, showErrors: false,
        onChange: (data) => props.onChange({
            ...data,
            vehicleNumberPart0: data.plate[0],
            vehicleNumberPart1: data.plate[1],
            vehicleNumberPart2: data.plate[2],
            vehicleNumberPart3: data.plate[3],
        }),
        option: {
            required: ({ input }) => input.field !== 'vehicleMake',
            labelType: () => 'online',
            className: () => inputCls
        },
        validations: {
            plate: ({ data }) => {
                const error = 'پلاک صحیح نیست'
                if (data.vehicleType?.id === 0) {
                    if (typeof data.vehicleNumberPart0 !== 'string' || data.vehicleNumberPart0.length !== 3) { return error }
                    if (typeof data.vehicleNumberPart1 !== 'string' || data.vehicleNumberPart1.length !== 5) { return error }
                }
                else {
                    if (typeof data.vehicleNumberPart0 !== 'string' || data.vehicleNumberPart0.length !== 2) { return error }
                    if (typeof data.vehicleNumberPart1 !== 'string' || data.vehicleNumberPart1.length !== 1) { return error }
                    if (typeof data.vehicleNumberPart2 !== 'string' || data.vehicleNumberPart2.length !== 3) { return error }
                    if (typeof data.vehicleNumberPart3 !== 'string' || data.vehicleNumberPart3.length !== 2) { return error }
                }
            }
        },
        inputs: {
            vehicleType: {
                label: 'نوع وسیله نقلیه', field: 'vehicleType.id', type: 'select', required: true,
                options: options.vehicleTypes.map((o: any) => ({ text: o.value, value: o.key })),
                popover: { fitHorizontal: true }
            },
            vehicleMake: {
                label: 'مدل وسیله نقلیه', field: 'vehicleMake.id', type: 'select', required: true,
                options: options.vehicleMakes.map((o: any) => ({ text: o.value, value: o.key })), search: 'جستجو',
                popover: { fitHorizontal: true }
            },
            vehicleVin: { label: 'شماره VIN', type: 'text', field: 'vehicleVin', required: true },
            vehicleInsuranceExpire: {
                label: 'تاریخ اعتبار بیمه نامه', field: 'vehicleInsuranceExpire', type: 'date', jalali: true, size: 16,
                after: <Icon path={mdiCalendar} size={0.8} color='#555' />, caret: false, placeholder: ' ', dateType: "dateObject"
            },
            carPlate: {
                label: 'پلاک', type: 'mask', field: 'plate', attrs: { style: { direction: 'ltr' } },
                maskPattern: [
                    { length: 2, type: 'number', after: '-' },
                    { type: 'select', after: '-', options: "fa-plate" },
                    { length: 3, type: 'number', after: '-' },
                    { length: 2, type: 'number' },
                ],
                validation: ['plate']
            },
            motoPlate: {
                label: 'پلاک', type: 'mask', field: 'plate', attrs: { style: { direction: 'ltr' } },
                maskPattern: [
                    { length: 3, type: 'number', after: '-' },
                    { length: 5, type: 'number' },
                ],
                validation: ['plate']
            },
            
        }
    })
    useEffect(() => {
        props.setDisabled(!!form.disabled)
    }, [form.disabled])
    const rowCls = 'p-v-12- gap-16-'
    const node: I_formNode<I_model> = {
        className: 'gap-16-',
        v: [
            {
                className: rowCls,
                h: [
                    { className: 'flex-1', input: 'vehicleType' },
                    { className: 'flex-1', input: 'vehicleMake' },
                    { className: 'flex-1', input: 'motoPlate', show: form.data.vehicleType?.id === 0 },
                    { className: 'flex-1', input: 'carPlate', show: form.data.vehicleType?.id !== 0 },
                    { className: 'flex-1', input: 'vehicleVin' }
                ]
            },
            {
                className: rowCls,
                h: [
                    { className: 'flex-1', input: 'vehicleInsuranceExpire' },
                    { className: 'flex-1', html: '' },
                    { className: 'flex-1', html: '' },
                    { className: 'flex-1', html: '' },
                ]
            }
        ]
    }
    return <>
        {form.render.layout(node)}
        {
            form.errorsList.length > 0 &&
            <div className="fs-12- m-t-8- p-h-12- flex-row- align-v- gap-6-" style={{ color: 'red' }}>
                <Icon path={mdiInformationOutline} size={0.8} color='red' />
                {form.errorsList[0]}
            </div>
        }
    </>
}